import React from 'react';
import clsx from 'clsx';

const paddingVariants = {
  none: '',
  compact: 'p-4',
  default: 'p-5',
  relaxed: 'p-6',
};

export function Card({
  children,
  className,
  hover = false,
  padding = 'default',
  accent = false,
  seriesAccent = false,
  ...props
}) {
  // Support boolean for backward compatibility
  const paddingClass = typeof padding === 'boolean'
    ? (padding ? 'p-4' : '')
    : (padding in paddingVariants ? paddingVariants[padding] : paddingVariants.default);

  return (
    <div
      className={clsx(
        'bg-white rounded-md border border-slate-200 shadow-sm',
        accent && 'border-t-2 border-t-wrg-blue-600',
        seriesAccent && 'border-t-2 border-t-series',
        hover && 'transition-all duration-100 hover:shadow-md hover:border-slate-300 cursor-pointer',
        paddingClass,
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
}

export function CardHeader({ children, className, border = true, ...props }) {
  return (
    <div
      className={clsx(
        'mb-3 pb-3',
        border && 'border-b border-slate-100',
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
}

export function CardTitle({ children, className, ...props }) {
  return (
    <h3 className={clsx('text-md font-semibold text-slate-800', className)} {...props}>
      {children}
    </h3>
  );
}

export function CardDescription({ children, className, ...props }) {
  return (
    <p className={clsx('text-sm text-slate-500 mt-1', className)} {...props}>
      {children}
    </p>
  );
}

export function CardContent({ children, className, ...props }) {
  return (
    <div className={clsx(className)} {...props}>
      {children}
    </div>
  );
}

export function CardFooter({ children, className, ...props }) {
  return (
    <div className={clsx('mt-4 pt-4 border-t border-slate-100', className)} {...props}>
      {children}
    </div>
  );
}
